import React, { useEffect } from "react";
import { useState } from "react";
import "./DealStatus.css";

const DealStatus = (props) => {
  const { dealStatus, setDealStatus, isUpdate, isBtnDisable } = props;
  const [currentDealStatus, setCurrentDealStatus] = useState(dealStatus);

  useEffect(() => {
    if (isUpdate === true) {
      setDealStatus(dealStatus);
    }
  }, []);
  useEffect(() => {
    setCurrentDealStatus(dealStatus);
  }, [dealStatus]);
  const handleOpen = () => {
    if (isBtnDisable === false) {
      setDealStatus("open");
    }
  };
  const handleWon = () => {
    if (isBtnDisable === false) {
      if (isUpdate === true) {
        setDealStatus("won");
      }
    }
  };
  const handleLost = () => {
    if (isBtnDisable === false) {
      if (isUpdate === true) {
        setDealStatus("lost");
      }
    }
  };
  console.log("isUpdate", isUpdate);
  return (
    <div
      className={`deal-status-container ${
        isBtnDisable === true && "custom-disable-card"
      }`}
    >
      {currentDealStatus == "open" ? (
        <div className="deal-status-btn deal-open-active-btn">Open</div>
      ) : currentDealStatus == "archived" ||
        currentDealStatus == "auto lost" ? (
        <div></div>
      ) : (
        <div className="deal-status-btn  deal-open" onClick={handleOpen}>
          Open
        </div>
      )}

      {isUpdate ? (
        currentDealStatus == "won" ? (
          <div className="deal-status-btn deal-won-active-btn">Won</div>
        ) : currentDealStatus == "archived" ||
          currentDealStatus == "auto lost" ? (
          <div></div>
        ) : (
          <div
            className={`deal-status-btn  deal-won  ${
              isUpdate === false ? "custom-opacity-class" : ""
            }`}
            onClick={handleWon}
          >
            Won
          </div>
        )
      ) : (
        ""
      )}

      {isUpdate ? (
        <>
          {currentDealStatus == "lost" ? (
            <div className="deal-status-btn deal-lost-active-btn">Lost</div>
          ) : currentDealStatus == "archived" ||
            currentDealStatus == "auto lost" ? (
            <div></div>
          ) : (
            <div
              className={`deal-status-btn  deal-lost ${
                isUpdate === false ? "custom-opacity-class" : ""
              }`}
              onClick={handleLost}
            >
              Lost
            </div>
          )}
          {currentDealStatus == "archived" ||
          currentDealStatus == "auto lost" ? (
            <div className="deal-status-btn deal-archived-active-btn">
              Archived
            </div>
          ) : ""
          }
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default DealStatus;
